import { DateTime } from 'luxon';

/**
 * Checks if the restaurant is currently open in German time (Europe/Berlin).
 * 
 * Monday: Closed
 * Tuesday - Sunday: 11:00 - 14:00 and 17:00 - 22:00
 * 
 * @returns {boolean} True if open, false otherwise.
 */
export const isRestaurantOpen = () => {
    // Get current time in German timezone
    const now = DateTime.now().setZone('Europe/Berlin');

    // Closed on 01.09.2026
    if (now.year === 2026 && now.month === 9 && now.day === 1) {
        return false;
    }

    // getDay() returns 1 for Monday, ..., 7 for Sunday in luxon (or check weekday)
    // weekday: 1 (Monday) to 7 (Sunday)
    if (now.weekday === 1) {
        return false;
    }

    const hour = now.hour;
    const minute = now.minute;
    const currentTimeInMinutes = hour * 60 + minute;

    // 11:00 = 660 mins, 14:00 = 840 mins
    // 17:00 = 1020 mins, 22:00 = 1320 mins

    const isLunch = currentTimeInMinutes >= 660 && currentTimeInMinutes < 840;
    const isDinner = currentTimeInMinutes >= 1020 && currentTimeInMinutes < 1320;

    return isLunch || isDinner;
};

/**
 * Formats the current status message for the user.
 * @returns {string} Status message.
 */
export const getRestaurantStatusMessage = () => {
    const now = DateTime.now().setZone('Europe/Berlin');

    if (now.year === 2026 && now.month === 9 && now.day === 1) {
        return "Entschuldigung, das Restaurant ist am 01.09.2026 geschlossen. Online-Bestellungen sind an diesem Tag leider nicht möglich.";
    }

    if (now.weekday === 1) {
        return "Heute (Montag) ist unser Ruhetag.";
    }

    return "Wir haben zurzeit geschlossen. Bestellungen und Reservierungen sind nur während unserer Öffnungszeiten (11:00-14:00 und 17:00-22:00) möglich.";
};
